export const LINK_TYPES = {
  email: 'email',
  phone: 'phone',
  url: 'url',
} as const;

type ObjectValues<T> = T[keyof T];
export type LinkTypeType = ObjectValues<typeof LINK_TYPES>;
